import { ref, defineComponent } from "vue";
import {
  VBtn,
  VIcon,
  VImg,
  VTooltip,
  VList,
  VListItem,
  VListItemContent,
  VListItemIcon,
} from "vuetify/lib";

import { previewFile } from "@/components/FormContent/methods.tsx";

import { app_android, app_apple, app_rustore } from "@/constants";

const Analytics = () => <img src="/img/analytics.jpeg" width="100%"></img>;

// const Waybills = () => <img src="/img/waybills.png" width="100%"></img>;

const Download = () => (
  <div style="display: flex; flex-wrap: wrap; justify-content: center; gap: 10px">
    <VBtn
      outlined
      style="border-color: rgba(0,0,0,0.12)"
      href={app_android.value}
      target="_blank"
      link
    >
      <VIcon>mdi-google-play</VIcon>
      <span>Скачать из Google&nbsp;Play</span>
    </VBtn>

    <VBtn
      outlined
      style="border-color: rgba(0,0,0,0.12)"
      href={app_apple.value}
      target="_blank"
      link
    >
      <VIcon>mdi-apple</VIcon>
      <span>Скачать из App&nbsp;Store</span>
    </VBtn>

    <VBtn
      outlined
      style="border-color: rgba(0,0,0,0.12)"
      href={app_rustore.value}
      target="_blank"
      link
    >
      <VImg
        src={require("@/assets/rustore-logo-black.svg")}
        max-width="24"
        max-height="24"
      ></VImg>
      <span>Скачать из RuStore</span>
    </VBtn>
  </div>
);
const PreviewPhoto = defineComponent({
  methods: {
    btn(color, hint, image) {
      const slots = {
        activator: ({ on }) => (
          <VBtn
            color={color}
            outlined
            small
            class="pa-2"
            style="min-width:0;border-color:rgba(0,0,0,0.12)"
            on={{ click: () => previewFile(0, "image", image), ...on }}
          >
            <VIcon small>mdi-camera</VIcon>
          </VBtn>
        ),
      };

      return (
        <VTooltip bottom scopedSlots={slots}>
          <span>{hint}</span>
        </VTooltip>
      );
    },
  },
  render() {
    return (
      <div>
        {this.btn("blue", "До погрузки", "/img/container_before.jpg")}
        <span class="mx-1"></span>
        {this.btn("green", "После погрузки", "/img/container_after.jpg")}
      </div>
    );
  },
});

export const features = ref([
  {
    icon: "mdi-poll",
    color: "orange",
    text: "Организация, учет и детальная аналитика погрузочных работ",
    component: Analytics,
  },
  {
    icon: "mdi-camera",
    color: "blue",
    text: "Фотографирование мусорных объектов до и после погрузки",
    component: PreviewPhoto,
  },
  {
    icon: "mdi-map-marker",
    color: "red",
    text: "Получение географических координат всех мусорных объектов",
  },
  {
    icon: "mdi-map-marker-path",
    color: "red",
    text: "Автоматическое формирование путевых листов",
    // component: Waybills,
  },
  {
    icon: "mdi-map-check-outline",
    color: "green",
    text: "Он-лайн отображение мусорных объектов и их статусов на карте",
    // to: "/map",
  },
]);

export const description = ref({
  brief: `Баласка - программный комплекс, предназначенный для автоматизации
          работы компаний, оказывающих услуги по вывозу мусора - строительного,
          производственного, бытового. Комплекс обеспечивает взаимодействие персонала
          (диспетчеры, водители мусоровозов) внутри компании, а также между компанией
          и потребителями услуг.`,
  full: `Комплекс Баласка разработан и используется компаниями в технологии
          SaaS (программное обеспечение как услуга). Это значит, что компании не
          нужны дорогостоящие сервера с технической поддержкой, забота о
          сохранности информации, установка и обновление программ, специалисты
          (программисты, системщики, операторы) для работы с комплексом. Все это
          берем на себя мы. Подключение за символическую плату, и обеспечена
          возможность работы диспетчеров и водителей 24 часа в сутки, 7 дней в
          неделю. Диспетчер может работать в Баласке с обычным, самым дешёвым
          ноутбуком, подключенным к интернет, в любом месте - в офисе, дома, на
          даче. Водитель может использовать приложение Баласка на любом
          смартфоне под Android в городе, селе, поле, горах. Заказчик может
          заказать вывоз мусора в приложении Баласка фактически одним нажатием
          кнопки «фото» в пределах географического ареала действия компании,
          вывозящей мусор.`,
});

export const components = ref([
  {
    brief: `Cайт, предназначенный для работы диспетчеров и управляющего персонала
            компании вывозящей мусор`,
    full: defineComponent({
      render() {
        const items = [
          <span>
            Позволяет удаленно управлять базами данных компании - видами мусора,
            типами и наличием контейнеров, автомобилями и спецтехникой, видами
            услуг, персоналом
          </span>,
          <span>
            Через сайт ведется учёт договоров, заказов, заявок потребителей
            услуг компании, составляются расписания и графики вывоза мусора
          </span>,
          <span>
            Диспетчеры могут формировать и корректировать путевые листы
            водителям мусоровозов (в том числе автоматически), общаться по
            собственной безопасной связи непосредственно с сайта с водителями и
            заказчиками посредством чатов и/или голоса
          </span>,
          <span>
            На сайте доступны различные формы отчетности и статистики для
            диспетчеров и управляющего персонала компании
          </span>,
          <span>
            Инфографика комплекса отображает на Яндекс-картах запланированные на
            этот день и отработанные водителями мусорные объекты в реальном
            режиме времени
          </span>,
        ];
        return (
          <VList>
            {items.map((item) => (
              <VListItem class="pl-1">
                <VListItemIcon class="mr-2 mt-2">
                  <VIcon>mdi-minus</VIcon>
                </VListItemIcon>
                <VListItemContent>{item}</VListItemContent>
              </VListItem>
            ))}
          </VList>
        );
      },
    }),
    full1: `
    Позволяет удаленно управлять базами данных компании - видами мусора,
            типами и наличием контейнеров, автомобилями и спецтехникой, видами
            услуг, персоналом. Через сайт ведется учёт договоров, заказов,
            заявок потребителей услуг компании, составляются расписания и
            графики вывоза мусора. Диспетчеры могут формировать и корректировать
            путевые листы водителям мусоровозов (в том числе автоматически),
            общаться по собственной безопасной связи непосредственно с сайта с
            водителями и заказчиками посредством чатов и/или голоса. На сайте
            доступны различные формы отчетности и статистики для диспетчеров и
            управляющего персонала компании. Инфографика комплекса отображает на
            Яндекс-картах запланированные на этот день и отработанные водителями
            мусорные объекты в реальном режиме времени.`,
  },
  {
    brief: `Приложение Баласка для смартфонов на базе Android для водителей
            мусоровозов`,
    full: defineComponent({
      render() {
        const items = [
          <span>
            Приложение спроектировано максимально просто и удобно для водителей,
            все функции интуитивно понятны, для его применения никакой
            специальной подготовки водителя не требуется
          </span>,
          <span>
            Приложение получает путевой лист на текущую дату, выстраивает список
            мусорных объектов для отработки по приоритетам, установленным
            диспетчером
          </span>,
          <span>
            Каждый объект (мусорный контейнер, площадка, свалка) в путевом листе
            имеет адрес и точные географические координаты
          </span>,
          <span>
            При желании водитель может двигаться к каждому объекту с помощью
            одного из наиболее популярных в РФ навигаторов, автоматически
            вызываемых из приложения
          </span>,
          <span>
            Водитель отмечает в приложении время выезда на каждый объект, по
            прибытии на объект фотографирует его с мусором, после погрузки
            фотографирует чистую площадку
          </span>,
          <span>
            Координаты, фото и время всех действий автоматически передаются на
            сервер и моментально доступны диспетчеру и заказчику
          </span>,
          <span>
            При невозможности осуществить погрузку мусора водитель снимает
            короткое видео с описанием причины, не позволившей погрузить мусор
          </span>,
          <span>
            В приложении также учитываются все выезды на мусорные полигоны в
            течение смены
          </span>,
          <span>
            Вход в приложение и его использование возможны после выдачи водителю
            диспетчером уникального логина/пароля
          </span>,
          <span>
            Водителю в любой момент доступен текстовый чат с диспетчером, а
            также возможность бесплатной голосовой связи с ним с использованием
            технологии РУССКИЙ ТЕЛЕФОН
          </span>,
          <span>
            В случае отсутствия интернет или неустойчивой связи во время
            движения мусоровоза, вся описанная технология отработки объектов
            сохраняется, данные автоматически передаются на сервер при
            восстановлении связи
          </span>,
        ];
        return (
          <div>
            <VList>
              {items.map((item) => (
                <VListItem class="pl-1">
                  <VListItemIcon class="mr-2 mt-2">
                    <VIcon>mdi-minus</VIcon>
                  </VListItemIcon>
                  <VListItemContent>{item}</VListItemContent>
                </VListItem>
              ))}
            </VList>

            <div style="text-align: center; padding: 10px">
              <Download></Download>
            </div>
          </div>
        );
      },
    }),
    full1: `Приложение спроектировано максимально просто и удобно для водителей,
            все функции интуитивно понятны, для его применения никакой специальной подготовки
            водителя не требуется. Приложение получает путевой
            лист на текущую дату, выстраивает список мусорных объектов для
            отработки по приоритетам, установленным диспетчером. Каждый объект
            (мусорный контейнер, площадка, свалка) в путевом листе имеет адрес и
            точные географические координаты. При желании водитель может
            двигаться к каждому объекту с помощью одного из наиболее популярных
            в РФ навигаторов, автоматически вызываемых из приложения. Водитель
            отмечает в приложении время выезда на каждый объект, по прибытии на
            объект фотографирует его с мусором, после погрузки фотографирует
            чистую площадку. Координаты, фото и время всех действий
            автоматически передаются на сервер и моментально доступны диспетчеру
            и заказчику. При невозможности осуществить погрузку мусора водитель
            снимает короткое видео с описанием причины, не позволившей погрузить
            мусор. В приложении также учитываются все выезды на мусорные
            полигоны в течение смены. Вход в приложение и его использование возможны
            после выдачи водителю диспетчером уникального
            логина/пароля. Водителю в любой момент доступен текстовый чат с
            диспетчером, а также возможность бесплатной голосовой связи с ним с
            использованием технологии РУССКИЙ ТЕЛЕФОН. В случае отсутствия
            интернет или неустойчивой связи во время движения мусоровоза, вся
            описанная технология отработки объектов сохраняется, данные
            автоматически передаются на сервер при восстановлении связи.`,
  },
  {
    brief: `Приложение Баласка для заказчиков вывоза мусора`,
    full: defineComponent({
      render() {
        const items = [
          <span>
            Приложение Баласка для заказчиков вывоза мусора доступно для
            смартфонов на базе Android и смартфонов iPhone
          </span>,
          <span>
            Для регистрации заказчика в Баласке требуется только номер телефона
            и E-mail заказчика
          </span>,
          <span>
            Оформление заказа на вывоз мусора реализовано максимально просто и
            удобно: одной кнопкой делается фотографирование мусорного объекта,
            определение точных географических координат, передача заказа
            диспетчеру
          </span>,
          <span>
            Дополнительно можно указать желательное время приезда мусоровоза,
            количество грузчиков
          </span>,
          <span>
            Автоматически по координатам выбирается компания по вывозу мусора,
            работающая в этом географическом ареале
          </span>,
          <span>
            Диспетчер выбранной компании по фотографии, координатам определяет
            вид транспорта, возможность его подачи в нужное время к объекту,
            рассчитывает цену по прейскуранту, присылает на смартфон заказчика
            счет на оплату
          </span>,
          <span>
            Заказчик оплачивает вывоз из приложения сразу банковской картой или
            оплачивает счет в банке, а диспетчеру в приложении присылает копию
            чека или платежного поручения
          </span>,
          <span>
            Для согласования дополнительных условий и нюансов в приложении
            Баласка реализован чат с диспетчером и водителем
          </span>,
          <span>
            Выезд водителя на объект, фото мусора по приезду, фотография
            окончания погрузки приложение заказчика получает мгновенными
            сообщениями с дублированием на электронную почту
          </span>,
        ];

        return (
          <div>
            <VList>
              {items.map((item) => (
                <VListItem class="pl-1">
                  <VListItemIcon class="mr-2 mt-2">
                    <VIcon>mdi-minus</VIcon>
                  </VListItemIcon>
                  <VListItemContent>{item}</VListItemContent>
                </VListItem>
              ))}
            </VList>

            <div style="text-align: center; padding: 10px">
              <Download></Download>
            </div>
          </div>
        );
      },
    }),
    full1: `Приложение Баласка для заказчиков вывоза мусора доступно для
            смартфонов на базе Android и смартфонов iPhone. Для регистрации
            заказчика в Баласке требуется только номер телефона и E-mail
            заказчика. Оформление заказа на вывоз мусора реализовано
            максимально просто и удобно: одной кнопкой делается
            фотографирование мусорного объекта, определение точных
            географических координат, передача заказа диспетчеру.
            Дополнительно можно указать желательное время приезда
            мусоровоза, количество грузчиков. Автоматически по координатам
            выбирается компания по вывозу мусора, работающая в этом
            географическом ареале. Диспетчер выбранной компании по
            фотографии, координатам определяет вид транспорта, возможность
            его подачи в нужное время к объекту, рассчитывает цену по
            прейскуранту, присылает на смартфон заказчика счет на оплату.
            Заказчик оплачивает вывоз из приложения сразу банковской картой
            или оплачивает счет в банке, а диспетчеру в приложении присылает
            копию чека или платежного поручения. Для согласования
            дополнительных условий и нюансов в приложении Баласка реализован
            чат с диспетчером и водителем. Выезд водителя на объект, фото
            мусора по приезду, фотография окончания погрузки приложение
            заказчика получает мгновенными сообщениями с дублированием на
            электронную почту.`,
  },
  {
    brief: "Баласка-Лайт",
    full: defineComponent({
      render() {
        return (
          <div>
            <p>
              Баласка-Лайт – серверная программа, принимающая заказы на вывоз
              мусора из приложений Баласка под Android и iOS и отправляющая их
              на E-mail диспетчера оператора вывоза мусора в указанном регионе.
            </p>
            <p>
              Потенциальный заказчик видит в приложении название оператора
              вывоза мусора, ссылку на его сайт, телефон диспетчера, адрес
              офиса. Сформировав заявку, заказчик отправляет диспетчеру фото
              мусорного объекта, точные географические координаты (и при
              возможности адрес ближайшего строения), желательную дату и время
              вывоза мусора, потребность в грузчиках, ФИО, свой номер телефон и
              E-mail.
            </p>
            <p>
              Дальнейшую обработку полученной заявки оператор вывоза мусора
              проводит самостоятельно, исходя из принятой в его предприятии
              технологии. Для полноценного использования программного комплекса
              Баласка (с приложениями водителей, полным учетом договоров
              мусорных объектов, формированием путевых листов, отчетами и т.д.)
              оператор вывоза мусора может заключить договор с нашим
              дистрибьютором, обратившись на E-mail{" "}
              <a href="mailto:support@balaska.ru">support@balaska.ru</a> или по
              тел. <a href="tel:+7 38557 444 74">+7 (38557) 444 74</a>.
            </p>
            <p>Стоимость одной заявки - 10руб.</p>
            <p>
              Зарегистрировать оператора вывоза мусора в Баласка-Лайт{" "}
              <a href="https://balaska.ru/#/register">
                https://balaska.ru/#/register
              </a>
            </p>
          </div>
        );
      },
    }),
  },
]);
